import { BaseRouteService } from "./BaseRouteService";

export interface QuestObjective {
    description: string;
    completed: boolean;
}

export interface QuestObjectivesResponse {
    title: string;
    objectives: string[]; // Update this to match
}

export class QuestService extends BaseRouteService {
    public async getObjectives(): Promise<QuestObjectivesResponse> {
        return this.getJsonApi("game/objectives"); // Calls the static endpoint
    }
}
